// extracted by mini-css-extract-plugin
var _1 = "UploadRestriction-module__message--AoJM1";
export { _1 as "message" }
